import { PciI } from "interfaces/Pci";
import { ReactNode } from "react";
import { Badge } from "react-bootstrap";

interface Props {
  elemento: PciI;
  renderActions?: (elemento: PciI) => ReactNode;
}

export const PCIRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`PCITable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>{elemento.anio_implementacion}</td>
        <td>{elemento.planEstudio?.nombre}</td>
        <td>{elemento.institucion?.nombre}</td>
        <td>
          {elemento.estado && (
            <Badge
              bg={"none"}
              style={{
                color: elemento.estado.textColor,
                backgroundColor: elemento.estado.backgroundColor,
                borderColor: elemento.estado.borderColor,
              }}
            >
              {elemento.estado.nombre}
            </Badge>
          )}
        </td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
